import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ORDERS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getPodOrdersAction = createAsyncThunk(
    'order/getPodOrdersAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ ORDERS_PATH }/all${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getPodOrdersSlice = createSlice({
    name: 'getPodOrdersSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        resetPodOrders: () => DEFAULT_STATE
    },
    extraReducers: builder => {
        builder.addCase(getPodOrdersAction.pending, () => STATE__API__STARTED);
        builder.addCase(getPodOrdersAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getPodOrdersAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { resetPodOrders } = getPodOrdersSlice.actions;
export const getPodOrdersState = (state) => state.order.getPodOrders;
export default getPodOrdersSlice.reducer;
